<template lang="pug">
div
  .columns.is-centered
    .column.is-8
      form(v-on:submit.prevent="submit")
        .box
          .field
            label.label {{$t('account.settings.picture_label')}}
            .is-artwork
              image-preview(v-model="picture" category="staff")
          b-field(grouped)
            b-field(:label="$t('account.settings.first_name_label')", expanded :type="errors.has('firstName') ? 'is-danger': ''" :message="errors.has('firstName') ? errors.first('firstName') : ''")
              b-input(v-model="firstName" icon="account" v-validate="'required'" name="firstName" :placeholder="$t('account.settings.first_name_placeholder')" data-vv-as="First name" expanded)
            b-field(:label="$t('account.settings.last_name_label')", expanded :type="errors.has('lastName') ? 'is-danger': ''" :message="errors.has('lastName') ? errors.first('lastName') : ''")
              b-input(v-model="lastName" icon="account" v-validate="'required'" name="lastName" :placeholder="$t('account.settings.last_name_placeholder')" data-vv-as="Last name" expanded)
          b-field(:label="$t('account.settings.phone_label')", :type="errors.has('phone') || phoneValid === false ? 'is-danger': ''" :message="errors.has('phone') ? errors.first('phone') : (phoneValid === false ? 'The phone number is invalid': '')")
            phone-input(v-model="phone" @input="(phone, valid) => phone ? phoneValid = valid : phoneValid = undefined" name="phone" :placeholder="$t('account.settings.phone_placeholder')")
          b-field(:label="$t('account.settings.email_label')" :type="errors.has('email') ? 'is-danger': ''" :message="errors.has('email') ? errors.first('email') : ''")
            b-input(:placeholder="$t('account.settings.email_placeholder')" name="email" v-validate="'email'" type="email" icon="email-outline" v-model="email" readonly)  
          b-field(:label="$t('account.settings.permission_label')")
            span.icon 
              i.mdi.mdi-key
            span {{$t(`access.${access}`)}}
        
          b-field( :label="$t('account.settings.locale')" :type="errors.has('locale') ? 'is-danger': ''" :message="errors.has('locale') ? errors.first('locale') : ''")
            b-select(v-model="locale" expanded name="locale" icon="earth")
              option(v-for="lang in locales" :value="lang") {{$t(`account.settings.languages.${lang}`)}}
      
        .box
          PushNotifications
        .field
          .control
            action-button(title="actions.save" @click="submit" :loading="submitting")
</template>

<script>
import {mapState, mapActions} from 'vuex'
import PushNotifications from '@/components/settings/PushNotifications.vue'

export default {
  name: 'PersonalSettings',
  components: {
    PushNotifications
  },
  data() {
    return {
      submitting: false,
      picture: null,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      locale: undefined,
      locales: ['hy', 'en', 'ru', 'it', 'id'],
      access: undefined,
      phone: null,
      phoneValid: undefined
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('company', ['company'])
  },
  created() {
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
    this.email = this.user.email
    this.locale = this.user.locale
    this.picture = this.user.picture
    this.access = this.user.access
    this.phone = this.user.phone
  },
  methods: {
    ...mapActions('auth', ['updateDetails']),
    async submit() {
      const valid = await this.$validator.validateAll()
      if (!valid || this.phoneValid === false) {
        return
      }
      this.submitting = true
      const data = {
        _id: this.user._id,
        firstName: this.firstName,
        phone: this.phone,
        lastName: this.lastName,
        locale: this.locale,
        picture: this.picture,
        email: this.email
      }
      try {
        await this.updateDetails(data)
        this.$buefy.toast.open({message: this.$t('status.save_success'), type: 'is-success', queue: false})
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    }
  }
}
</script>
